<template>
    <front-layout>
        <div class="flex-wrapper-full-background d-flex  fill-height" style="width: 100%">
            <v-card class="mx-auto my-auto pa-5" max-width="900" min-width="500" raised>
                <v-card-title>
                    <span>{{ $t('general.sign-up') }}</span>
                </v-card-title>
                <v-container>
                    <v-form>
                        <v-row>
                            <v-col>
                                <v-text-field  :error-messages="errors.email"  :label="$t('general.email')" v-model="email"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field  :error-messages="errors.password"  type="password" :label="$t('general.password')" v-model="password"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field type="password" :error-messages="errors.password_confirmation"  :label="$t('general.password')" v-model="password_confirmation"/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                    label="Select a localization"
                                    :items="['English', 'Dutch']"
                                    @input="setLocale"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn @click="handleSignUp">{{ $t('general.sign-up') }}</v-btn>
                            </v-col>
                            <!--     <v-col>
                                     <login-with-github />
                                 </v-col>
                                 <v-col>
                                     <login-with-google />
                                 </v-col>-->
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </div>
    </front-layout>
</template>

<script>
    import FrontLayout from "../layouts/FrontLayout";

    export default {
        name: "Login",
        components: {FrontLayout},
        data: function () {
            return {
                email: '',
                password: '',
                password_confirmation: '',
                errors: {},
                user: [],
                locale: 'us'
            }
        },
        methods: {
            async handleSignUp() {
                const {email, password, password_confirmation, locale} = this;
                await this.$auth.register({
                    data: {email, password, password_confirmation, locale},
                    success() {
                        this.$auth.ready();
                    },
                    staySignedIn: true,
                    redirect: {name: 'dashboard.index'},

                }).catch(e => this.errors = e.response.data.errors)
            },
            setLocale(locale) {
                if (locale === 'English') {
                    this.$i18n.locale = 'us'
                    this.locale = 'us'
                } else {
                    this.$i18n.locale = 'nl'
                    this.locale = 'nl'
                }
            }
        }
    }
</script>

<style scoped lang="scss">
.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,.42);
    padding-bottom: 3px;
}
</style>
